import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { FormsModule } from '@angular/forms';
import { RestService } from '../rest.service';
import { InmueblesService } from '../inmuebles.service';
import { SideService } from '../side.service';
import { UserService } from '../user.service';
import { AcuerdosService } from '../acuerdos.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  toggleFormClass;

  user = '';
  loading: boolean = false;
  password = '';
  verified: boolean = true;

  constructor(public app: AppComponent,
    public rest: RestService,
    public dataUser: UserService,
    public acuerdosService: AcuerdosService,
    public side: SideService,
    public inmuebles: InmueblesService) {

      if (typeof(Storage) !== 'undefined') {
          this.user = localStorage.getItem('user');
          this.password = localStorage.getItem('password');
      }
    }

  ngOnInit() {
    this.acuerdosService.GetData();
    this.acuerdosService.GetFamilias();
    // this.getLocation();
    // this.login();
  }

  showSignUp() {
    this.toggleFormClass = 'bounceLeft';
  }

  showLogin() {
    this.toggleFormClass = 'bounceRight';
  }


  login() {

    this.loading = true;
    this.rest.postLogin(this.user, this.password).subscribe((data) => {

      if (data['status'] === '200') {
        localStorage.setItem('user', this.user);
        localStorage.setItem('password', this.password);
        // this.dataUser.sala_id = data['data'][0]['sala_id'];
        // this.dataUser.sala_id = data['data'][0]['sala_id'];
        this.dataUser.pass = this.password;
        this.dataUser.email = this.user;
        this.dataUser.user_id = data['data'][0]['id'];
        this.dataUser.sala_id = data['data'][0]['sala_id'];
        this.dataUser.parking_id = data['data'][0]['parking_id'];
        this.dataUser.sala_nombre = data['data'][0]['sala_nombre'];
        this.dataUser.permisos = data['data'][0]['permisos'];
        this.dataUser.data = data['data'];

        this.rest.postPermisos(data['data'][0]['id']).subscribe( (data) => {

          this.side.items = data['data']['permisos'];
          this.loading = false;
          this.app.authenticated = true;

        },(error) => {
          this.loading = true;
          alert('Error en conexión con el servidor, intentelo de nuevo');
        });

      } else {

        this.verified = false;
        setTimeout(() => {
          this.verified = true;
        }, 4500);
        this.loading = false;

      }

    },(error) => {
      this.loading = false;
      alert('Error en conexión con el servidor, intentelo de nuevo');
    });
  }

  getLocation() {
    this.rest.getGeolocation(100000, '', '', '', 'precio', '')
      .subscribe((data) => {
        this.inmuebles.setInmuebles(data['data']);
      });
  }

}
